import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)
export default new Vuex.Store({
  state: {

    currentUser: null,
    currentCenter: null,
    centers: null,

    modalVisible: false,
    modalComponent: null,

  },
  mutations: {
    showModal(state, componentName) {
      state.modalVisible = true;
      state.modalComponent = componentName;
    },
    hideModal(state) {
      state.modalVisible = false;
    },
    setUser(state, user) {
      state.currentUser = user;
    },
    setCurrentCenter(state, center) {
      state.currentCenter = center;
    },
    setCenters(state, centers) {
      state.centers = centers;
    },


    fillOutName() {}


  },
  getters: {
    currentUser: state => state.currentUser,
    currentCenter: state => state.currentCenter,
    centers: state => state.centers,

  },
  actions: {},
  modules: {}
})